import { useCandidateRedux } from "#candidate/redux/slice"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { Stack } from "@mui/material"
import { CandidateEditFields } from "../candidate-edit/CandidateEditFields"
export default function CandidateDetailsEdit({ setOpen, open, ...props }) {
	const { candidate } = useCandidateRedux()

	return (
		<DialogMaster
			{...{
				setOpen,
				title: "editar candidato",
				open,
				maxWidth: "sm",
			}}
		>
			<Stack spacing={2} width={"100%"}>
				<CandidateEditFields id="name" label="Nombre" datum={candidate?.name} />
				<CandidateEditFields
					id="paternal_last_name"
					label="Apellido Paterno"
					datum={candidate?.paternal_last_name}
				/>
				<CandidateEditFields
					id="maternal_last_name"
					label="Apellido Materno"
					datum={candidate?.maternal_last_name}
				/>
				<CandidateEditFields id="correo" label="Correo" datum={candidate?.correo} />
				<CandidateEditFields
					id="celular"
					label="Celular"
					datum={candidate?.celular}
					number
				/>
			</Stack>
		</DialogMaster>
	)
}
